import { render } from "./Certificate.vue?vue&type=template&id=3c59b146"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
script.render = render

export default script